// 意大得语
export const GUIDES = [
  { name: 'guide-overview', title: 'Panoramica delle funzioni', groupIndex: 0 },
  { name: 'guide-account', title: 'Informazioni sul conto', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Informazioni sul veicolo', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Come impostare il cruscotto', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Come impostare il veicolo', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Come navigare per trovare il veicolo', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Come utilizzare la navigazione', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Informazioni sulla cronologia di marcia', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: `Come eseguire un'autoispezione del veicolo`, groupIndex: 3 },
  { name: 'guide-useSetting', title: `Come configurare le impostazioni generali dell'APP`, groupIndex: 3 },
  { name: 'guide-notice', title: 'Come visualizzare e impostare la notifica dei messaggi', groupIndex: 3 },
  { name: 'guide-about', title: 'A proposito di APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'In attesa di',
  1: 'Nessuna risposta',
  2: 'Risposte',
  3: 'nella comunicazione',
  4: 'contromisure',
  5: 'risolto',
};

export const FEEDBACK_TYPES = {
  1: 'Feedback',
  2: 'Risposta',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
